import React from 'react';
import classes from './Button.module.css';

const button = (props) => (
  <button
    name={props.btnType}
    disabled={props.disabled}
    onClick={props.clicked}
    id={props.id}
    className={[classes.Button, classes[props.btnType]].join(' ')}
  >
    {props.children}
  </button>
);

export default button;
